import { useCallback } from 'react';
import {
  useDismissCatalogReleaseEventMutation,
  useGetCatalogReleaseEventsQuery,
  useLinkCatalogItemMutation,
} from '../../../../redux/api/fymAPI';
import { CatalogReleaseEvent } from '../../../../redux/api/fymAPI.types';

const NO_EVENTS: CatalogReleaseEvent[] = [];

interface UseReleaseEventsProps {
  accountId: number;
}

/**
 * The open release-day events of the catalog (design g3, D21): `GET .../catalog/release-events`.
 * `dismiss` closes a card for good (a linked card, or "No" on an ask card). `link` answers "Yes,
 * link it": the unreleased row becomes the released track (`POST .../catalog/:uuid/link`), and
 * the server closes the event.
 */
export function useReleaseEvents({ accountId }: UseReleaseEventsProps) {
  const { data } = useGetCatalogReleaseEventsQuery({ accountId });
  const [dismissEvent, dismissState] = useDismissCatalogReleaseEventMutation();
  const [linkItem, linkState] = useLinkCatalogItemMutation();

  const dismiss = useCallback(
    (event: CatalogReleaseEvent) => {
      dismissEvent({ accountId, eventId: event.id }).catch(console.error);
    },
    [accountId, dismissEvent]
  );

  const link = useCallback(
    (event: CatalogReleaseEvent) => {
      linkItem({ accountId, itemUuid: event.catalogItemUuid, maid: event.candidate.maid }).catch(console.error);
    },
    [accountId, linkItem]
  );

  return {
    events: data?.events ?? NO_EVENTS,
    dismiss,
    link,
    isBusy: dismissState.isLoading || linkState.isLoading,
    error: dismissState.error ?? linkState.error,
  };
}
